import Store from '@repo/datalayer/store/models/Store'
import { createContext, useContext } from 'react'
import { RootRouterStore } from '../store/RootRouterStore'

export const RootRouterStoreContext = createContext<RootRouterStore | null>(
  null
)

export function useRouter() {
  const found = useContext(RootRouterStoreContext)

  if (!found) throw 'RootRouterStoreContext not set'

  return found
}
